import axios from 'axios';
import IP from '../StoreGlobal/IP';
import { store } from 'src/store/store';
import { setToken, clearAuth } from 'src/store/feature/auth/authSlice';
import { LogoutUser } from 'src/request/Auth';
const $axios = axios.create({
  baseURL: IP,
});

let isLoggingOut = false;
let isRefreshing = false;
let refreshPromise = null;
let subscribers = [];

const forceLogout = () => {
  isLoggingOut = false;
  isRefreshing = false;
  subscribers = [];
  store.dispatch(clearAuth());
  localStorage.clear();
  window.location.href = '/';
}

const onRefreshed = (newToken) => {
  subscribers.forEach((cb) => cb(newToken));
  subscribers = [];
}

const subscribeTokenRefresh = (cb) => {
  subscribers.push(cb);
}

$axios.interceptors.request.use(
  async (config) => {

    if (isRefreshing && refreshPromise) {
      await new Promise((resolve) => {
        subscribeTokenRefresh(resolve);
      });
    }
    const token = store.getState().auth.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

$axios.interceptors.response.use(
  async (response) => {
    const newToken = response.headers["x-new-token"];
    const currentToken = store.getState().auth.token;

    if (newToken === currentToken) {
      return response;
    }
    if (newToken) {
      if (!isRefreshing) {
        isRefreshing = true;
        refreshPromise = Promise.resolve().then(() => {
          store.dispatch(setToken(newToken));
          onRefreshed(newToken);
          console.log('Token issued: ', new Date());
          isRefreshing = false;
          refreshPromise = null;
        });
        await refreshPromise;
      }
    }
    return response;
  },
  async (error) => {
    const status = error.response?.status;
    const originalRequest = error.config;

    if (status !== 401 || !originalRequest) {
      return Promise.reject(error);
    }

    if (!originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const onGoingRefresh = isRefreshing && refreshPromise;

        if (onGoingRefresh) {
          await refreshPromise;
        }

        const latestToken = store.getState().auth.token;
        if (latestToken) {
          originalRequest.headers.Authorization = `Bearer ${latestToken}`;
          return await $axios(originalRequest);
        }

      } catch (retryError) {
        console.warn('Retry after 401 failed', retryError);
      }
    }


    if (!isLoggingOut) {
      isLoggingOut = true;

      try {
        await LogoutUser();
      } catch (logoutError) {
        console.error('Failed to flush user token', logoutError);
      } finally {
        forceLogout();
      }
      return Promise.reject(error);
    }
  }
)

export default $axios;
